module.exports = __webpack_public_path__ + "img/logo-like.06204d52.svg";